<template>
  <div class="bd-head">
    <!-- <div class="logo">通航飞行管控系统</div> -->

    <div class="logo">
      <img src="../../assets/LG.png" />
      通航飞行管控系统
    </div>

    <Nav />
  </div>
</template>

<script>
import Nav from "../Nav/index.vue";
import svgPlot from "../SvgPlot/index.vue";
import basePlot from "../SvgPlot/base.vue";
import Analysis from "../Analysis/index.vue";
export default {
  components: {
    Nav,
  },
  data() {
    return {
      options: [
        { name: "空间分析", method: "analysis" },
        { name: "基础标绘", method: "base" },
        { name: "态势标绘", method: "plot" },
        { name: "态势演播" },
        { name: "系统设置" },
      ],
    };
  },
  mounted() {},
  methods: {
    selectChange(item) {
      var method = item.method;
      this[method] && this[method]();
    },
    analysis() {
      this.$dialog.open({
        title: "空间分析",
        area: {
          height: "880px",
          width: "300px",
        },
        location: {
          top: "56px",
          left: "0",
        },
        content: {
          type: "vue",
          subCom: Analysis,
        },
      });
    },
    base() {
      this.$dialog.open({
        title: "基础标绘",
        area: {
          height: "880px",
          width: "300px",
        },
        location: {
          top: "56px",
          left: "0",
        },
        content: {
          type: "vue",
          subCom: basePlot,
        },
      });
    },
    //态势标绘
    plot() {
      this.$dialog.open({
        title: "标准军标库",
        area: {
          height: "880px",
          width: "300px",
        },
        location: {
          top: "56px",
          left: "0",
        },
        content: {
          type: "vue",
          subCom: svgPlot,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  display: flex;
  align-items: center;
  // font-size: 2.125rem;
  font-size: 1.8rem;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 700;
  color: #ffffff;
  line-height: 40px;
  letter-spacing: 4px;
  justify-content: center;
  // font-size: 24px;
  // font-weight: 700;
  // color: #fff;
  // font-family: Microsoft YaHei;
  // text-shadow: 0 2px 6px #123756;
  // z-index: 9;
  // background-image: url("../../assets/heade-title-bg.png");
  // width: 220px;
  // height: 100%;
  // background-size: cover;
  // padding: 0 20px;

  img {
    width: 60px;
    margin-top: 4px;
  }
}

.bd-head {
  position: relative;
  top: 0;
  left: 0;
  height: 50px;
  width: 100%;
  // background-color: rgba(#173147, 0.9);
  background-image: url("../../assets/dbbg3.png");
  background-size: 100% 100%;
  z-index: 2;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}
</style>
